import AdminScripts from './container';

export default AdminScripts;
